export default function checkstock (input) {
    let inventory = input;
    if (inventory > 250) {
        inventory = '>250'
    } else if(inventory < 0) {
        inventory = 0;
    }
    return inventory;
    //return Number(input).toLocaleString();
}